import { useParams } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Forecast } from 'src/features/forecast/Forecast';
import { PageLayout } from 'src/layouts/PageLayout';

export function ForecastSkuPage(): ReactElement {
  const { t } = useTranslation('forecast');
  const { sku } = useParams({ from: '/forecast/$sku' });

  return (
    <PageLayout title={`${t('Forecast')} ${sku}`}>
      <Forecast sku={sku} />
    </PageLayout>
  );
}
